import React from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { useTranslation } from 'react-i18next';
import DatePickerLayout from './DatePicker';

const PpCmsFilter = ({ setDate, date, setSortOrder, getData, setSearchTitle }) => {
  const { t } = useTranslation();

  return (
    <div className="row justify-center ">
      <div className={ 'col-lg-12  my-2' }>
        <label>{ t('Title') }</label>
        <input
          type="text"
          className=" border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-2.5 mt-2"
          onChange={ (e) => setSearchTitle(e.target.value) }
        />
      </div>
      <div className="col-lg-6 mt-2">
        <select
          type="text"
          id="title"
          onChange={(e) => setSortOrder(e.target.value)}
          className="form-control border rounded-lg p-2 focus:outline-none focus:ring-green-500 focus:border-green-500"
          placeholder="Filter by title"
        >
          <option value={0}>{t('A-Z')}</option>
          <option value={1}>{t('Z-A')}</option>
        </select>
      </div>

      <div className="col-lg-6 ">
        <DatePickerLayout selectedDate={date} keyValue={'to'} dateTo={date} setDateTo={setDate} />
      </div>

      <div className="flex justify-center mt-3 ">
        <button
          onClick={getData}
          className="bg-customgreen text-white rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-green-500 w-32 "
        >
          {t('Search')}
        </button>
      </div>
    </div>
  );
};

export default PpCmsFilter;
